// routeUtils.js
import React from 'react';
import { jwtDecode } from 'jwt-decode';
import { additionalRoutes, baseRoutes, clientRoutes } from 'routes/routeConfig';

export const getClientName = () => {
  const domain = window.location.hostname;
  return domain?.split('.')[0].toUpperCase();
};

export const getTenantFromToken = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const decodedToken = jwtDecode(token);
  return decodedToken?.tenant_id;
};

export const generateClientRoutes = (clientName, tenantId) => {
  if (!clientName || !tenantId) return [];

  const processRoute = (route, tenantId) => {
    const processedRoute = {
      name: route.name,
      icon: <route.icon />,
      to: `/${tenantId}/${route.path}`,
      active: route.active,
      img: route.img
    };

    // Handle nested children recursively
    if (route.children) {
      processedRoute.children = route.children.map(childRoute =>
        processRoute(childRoute, tenantId)
      );
    }

    return processedRoute;
  };

  // Start with base routes
  const routes = Object.values(baseRoutes).map(route =>
    processRoute(route, tenantId)
  );

  // Add client-specific routes
  const clientConfig = clientRoutes[clientName];
  if (clientConfig) {
    clientConfig.additionalRoutes.forEach(routeKey => {
      const route = additionalRoutes[routeKey];
      if (route) {
        routes.push(processRoute(route, tenantId));
      }
    });
  }

  return [
    {
      label: '',
      labelDisable: false,
      children: routes
    }
  ];
};
